<template>
  <div class="schedule" >
    <el-divider content-position="left">公司申请政策列表</el-divider>
    <div style="width: 100%">
      <div style="width: 100%">
        <el-select
          v-model="searchForm.companyId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入公司名称筛选公司"
          size="mini"
          clearable
          :remote-method="searchRemoteCompanyMethodS"
          :loading="searchLoading"
          @change="toSearch"
        >
          <el-option
            v-for="searchCompany in searchCompaniesx"
            :key="searchCompany.id"
            :label="searchCompany.company_name"
            :value="searchCompany.id"
          >
          </el-option>
        </el-select>
        &nbsp;&nbsp;&nbsp;
        <el-select
          v-model="searchForm.app_status"
          size="mini"
          clearable
          @change="compAppStatus"
        >
          <el-option value="1" label="申请中">申请中</el-option>
          <el-option value="2" label="申请成功">申请成功</el-option>
          <el-option value="3" label="驳回">驳回</el-option>
        </el-select>
        &nbsp;&nbsp;&nbsp;
        <el-select
          v-model="searchForm.the_founder"
          placeholder="请选择创建人"
          size="mini"
          filterable
          style="width: 10%"
          clearable
          @change="founderUserfun"
        >
          <el-option
            v-for="item in adminUserOptions"
            :key="item.id"
            :label="item.username"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!--&nbsp;&nbsp;&nbsp;-->
        <!--<el-select-->
          <!--v-model="searchForm.doner_id"-->
          <!--placeholder="请选择操作人"-->
          <!--size="mini"-->
          <!--filterable-->
          <!--style="width: 10%"-->
          <!--clearable-->
          <!--@change="donerUserfun"-->
        <!--&gt;-->
          <!--<el-option-->
            <!--v-for="item in adminUserOptions"-->
            <!--:key="item.id"-->
            <!--:label="item.username"-->
            <!--:value="item.id"-->
          <!--&gt;-->
          <!--</el-option>-->
        <!--</el-select>-->
        &nbsp;&nbsp;&nbsp;
        <el-button type="primary" size="mini" @click="loadTable">查询</el-button>
      </div>
      <div style="width: 100%">
        <el-collapse v-model="activeNames" style="border-top: none; width: 100%" id="servicein">
          <el-collapse-item title="" name="2">
            <template slot="title">
              <span style="color: #409eff">数据统计</span>
            </template>
            <el-row :gutter="20">
              <el-col :span="4">
                <el-card shadow="hover">
                  <div class="item-title">申请状态</div>
                  <div class="item-title">
                    <div class="item-content">
                      <el-row
                        type="flex"
                        class="item-row"
                        style="color: #409eff"
                        justify="center"
                        :gutter="12"
                      >
                        <el-col :span="14" style="white-space: nowrap">申请中</el-col>
                        <el-col :span="10" style="color: ">{{statusing }}</el-col>
                      </el-row>
                      <el-row
                        type="flex"
                        class="item-row"
                        style="color: #67c23a"
                        justify="center"
                        :gutter="12"
                      >
                        <el-col :span="14" style="white-space: nowrap">申请成功</el-col>
                        <el-col :span="10" style="color: #67c23a">{{statussess }}</el-col>
                      </el-row>
                      <el-row
                        type="flex"
                        class="item-row"
                        style="color: "
                        justify="center"
                        :gutter="12"
                      >
                        <el-col :span="14" style="white-space: nowrap">申请失败</el-col>
                        <el-col :span="10" style="color: ">{{statusno}}</el-col>

                      </el-row>
                      <el-row
                        type="flex"
                        class="item-row"
                        style="color: violet"
                        justify="center"
                        :gutter="12"
                      >
                        <el-col :span="14" style="white-space: nowrap">匹配金额</el-col>
                        <el-col :span="10" style="color: ">{{countPpMoney}}</el-col>

                      </el-row>
                      <el-row
                        type="flex"
                        class="item-row"
                        style="color:darkcyan "
                        justify="center"
                        :gutter="12"
                      >
                        <el-col :span="14" style="white-space: nowrap">实际申请金额</el-col>
                        <el-col :span="10" style="color: ">{{countActualMoney}}</el-col>
                      </el-row>
                      <el-row
                        type="flex"
                        class="item-row"
                        style="color:darkcyan "
                        justify="center"
                        :gutter="12"
                      >
                        <el-col :span="14" style="white-space: nowrap;color: red" >总政策数</el-col>
                        <el-col :span="10" style="color: red">{{count}}</el-col>
                      </el-row>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div style="text-align: right; flex: 1;margin-top: 10px">
      <el-button type="primary" size="mini" @click="categoryIn">录入</el-button>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em;">
        <el-form
          :model="addForm"
          :rules="rules"
          ref="addForm"
          label-width="100px"
        >
          <el-form-item label="选择公司" prop="company_id">
            <el-select
              v-model="addForm.company_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司名称筛选公司"
              size="mini"
              clearable
              :remote-method="searchRemoteCompanyMethod"
              :loading="searchLoading"
              @change="getComUser"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchCompanies"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择政策" prop="policy_id">
            <el-select
              v-model="addForm.policy_id"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in policyObj"
                :key="item.id"
                :label="item.policy_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配金额：" prop="pp_money">
            <el-input v-model="addForm.pp_money" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="创建人"
            prop="the_founder"
          >
            <el-select
              v-model="addForm.the_founder"
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="办理人"
            prop="doner_id"
          >
            <el-select
              v-model="addForm.doner_id"
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请描述：" prop="app_why">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="addForm.app_why">
            </el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('addForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"

      :visible.sync="EditDrawer"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em;">
        <el-form
          :model="editForm"
          :rules="rules"
          ref="editForm"
          label-width="100px"
        >
          <el-form-item label="已选择公司" prop="company_id">
            <el-input v-model="editForm.company_name" size="mini" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="已选择政策" prop="policy_id">
            <el-select
              v-model="editForm.policy_id"
              :disabled="editForm.app_status === 2 || editForm.app_status === 3"
              :data-status="editForm.status ||'xx'"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in policyObj"
                :key="item.id"
                :label="item.policy_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配金额：" prop="pp_money">
            <el-input v-model="editForm.pp_money" :disabled="editForm.app_status === 2 || editForm.app_status === 3" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="办理人"
            prop="doner_id"
          >
            <el-select
              v-model="editForm.doner_id"
              :disabled="editForm.app_status === 2 || editForm.app_status === 3"
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：" prop="app_status">
            <el-radio-group v-model="editForm.status" size="mini">
              <el-radio-button label="1">正常</el-radio-button>
              <el-radio-button label="2">删除</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editFormFun('editForm')"
            >编辑</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="distributeDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">政策申请反馈</span>
      </template>
      <div v-if="editForm.dais === 1">
        <el-form
          :model="editForm"
          ref="editForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="已选择公司" prop="company_id">
            <el-input v-model="editForm.company_name" size="mini" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="已选择政策" prop="policy_id">
            <el-select
              v-model="editForm.policy_id"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in policyObj"
                :key="item.id"
                :label="item.policy_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配金额：" prop="pp_money">
            <el-input v-model="editForm.pp_money" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="办理人"
            prop="doner_id"
          >
            <el-select
              v-model="editForm.doner_id"
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!--<el-form-item label="状态：" prop="app_status">-->
            <!--<el-radio-group v-model="editForm.status" size="mini">-->
              <!--<el-radio-button label="1">正常</el-radio-button>-->
              <!--<el-radio-button label="2">删除</el-radio-button>-->
            <!--</el-radio-group>-->
          <!--</el-form-item>-->
          <el-form-item label="审核：" prop="app_status">
            <el-radio-group v-model="editForm.app_status" size="mini" @change="appStatus">
              <el-radio-button label="1">申请中</el-radio-button>
              <el-radio-button label="2">申请成功</el-radio-button>
              <el-radio-button label="3">驳回</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="实际金额：" prop="actual_money" v-if="success">
            <el-input v-model="editForm.actual_money" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="说明：" prop="rejected">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="editForm.rejected">
            </el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="tiJiaoFun('editForm')"
            >提交反馈</el-button
            >
          </div>
        </el-form>
      </div>
      <div v-else style="padding: 0.2em 1.4em; margin-top: -17px">
        <div style="margin-bottom: 0.28rem; color: #409eff">反馈记录</div>
        <div class="block">
          <el-timeline>
            <el-timeline-item
              :timestamp="item.created_at"
              placement="top"
              v-for="item in FOptions"
              :key="item.id"
            >
              <el-card>
                <h4 style="margin-bottom: 0.28rem">
                  <span>反馈状态：</span>
                  <span v-if="item.app_status === 1" style="color: #0000cc">申请中</span>
                  <span v-else-if="item.app_status === 2" style="color: green">申请成功</span>
                  <span v-else style="color: red">驳回</span>
                </h4>
                <h4 style="margin-bottom: 0.28rem">
                  <span>反馈内容：</span><span>{{ item.rejected }}</span>
                </h4>
                <p style="margin-bottom: 0.28rem">
                  <span>反馈人：</span><span>{{ item.username }}</span>
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="政策详情"
      :visible.sync="policyInfoDrawer"
      direction="rtl"
      size="35%"
      :before-close="handleOrderInfoClose"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <el-col style="font-size: 20px;padding-bottom: 10px;">{{policyInfoArr.company_name}}</el-col>
          <el-col>
            <table border="1" style="border-color: #cccccc;font-size: 14px;font-weight: 400">
              <tr>
                <th>政策名称</th>
                <td colspan="11">{{policyInfoArr.policy_name}}</td>
              </tr>
              <tr>
                <th>省</th>
                <td colspan="3">{{policyInfoArr.provinces}}</td>
                <th>市</th>
                <td colspan="3">{{policyInfoArr.city}}</td>
                <th>区</th>
                <td colspan="3">{{policyInfoArr.area}}</td>
              </tr>
              <tr>
                <th>园区</th>
                <td colspan="11">{{policyInfoArr.the_park}}</td>
              </tr>
              <tr>
                <th>补贴金额</th>
                <td colspan="5">{{policyInfoArr.amount}} 元</td>
                <th>享受次数</th>
                <td colspan="5">
                  <span v-if="policyInfoArr.enjoy_number === 1">一次</span>
                  <span v-else>多次</span>
                </td>
              </tr>
              <tr>
                <th>企业行业</th>
                <td colspan="11">{{policyInfoArr.requirements}}</td>
              </tr>
              <tr>
                <th>状态</th>
                <td colspan="11">
                  <span v-if="policyInfoArr.status === 1">正常</span>
                  <span v-else>删除</span>
                </td>
              </tr>
              <tr>
                <th>内容</th>
                <td colspan="11">{{policyInfoArr.instructions}}</td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <div class="middle-table">
    <el-table
      height="calc(100vh - 346px)"
      :data="companyPolicy"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID" width="80" fixed></el-table-column>
      <el-table-column prop="company_name" label="公司名称">
      </el-table-column>
      <el-table-column prop="policy_name" label="政策名称">
        <template slot-scope="scope">
          <el-link
            type="primary"
            @click="handlePolicyInfo(scope.row.policy_id, scope.row.company_name)"
          >{{ scope.row.policy_name }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="pp_money" label="匹配金额"> </el-table-column>
      <el-table-column prop="the_founder_username" label="创建人"> </el-table-column>
      <el-table-column prop="app_status" label="申请状态">
        <template slot-scope="scope">
          <span v-if="scope.row.app_status === 1" style="color: navy">申请中</span>
          <span v-else-if="scope.row.app_status === 2" style="color: green">申请成功</span>
          <span v-else style="color: red">驳 回</span>
        </template>
      </el-table-column>
      <el-table-column prop="app_why" label="申请描述"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" style="color: green">正常</span>
          <span v-else style="color: red">删除</span>
        </template>
      </el-table-column>
      <el-table-column prop="doner_username" label="办理人"> </el-table-column>
      <el-table-column prop="actual_money" label="实际申请金额" width="120"> </el-table-column>
      <el-table-column prop="feed.rejected" label="最近一次反馈描述" width="150"></el-table-column>
      <el-table-column prop="feed.created_at" label="最近一次反馈时间" width="140">
        <template slot-scope="scope">
          <date-formatter :date-value="feed.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="反馈" placement="top">
            <el-button
              @click.native.prevent="openDistribute(scope.row)"
              type="success"
              size="mini"
              icon="el-icon-document-add"
              circle
              v-if="scope.row.status === 1"
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
              v-if="scope.row.status === 1"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
export default {
  name: 'ApplicationPolicy',
  components: { DateFormatter },
  data () {
    var CompanyId = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择公司！'))
      }
      callback()
    }
    var PolicyId = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择政策！'))
      }
      callback()
    }
    var PpMoney = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请填写匹配金额！'))
      }
      const age = /^[0-9]*$/
      if (!age.test(value)) {
        callback(new Error('金额只能为整数'))
      }
      callback()
    }
    var ActualMoney = (rule, value, callback) => {
      const age = /^[0-9]*$/
      if (!age.test(value)) {
        callback(new Error('金额只能为整数'))
      }
      callback()
    }
    var DonerId = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择办理人！'))
      }
      callback()
    }
    var TheFounder = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择创建人！'))
      }
      callback()
    }
    var AppStatus = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择审核状态！'))
      }
      callback()
    }
    var AppWhy = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请填写申请描述！'))
      }
      callback()
    }
    // var Rejected = (rule, value, callback) => {
    //   if (value.length === 0) {
    //     return callback(new Error('请输入说明！'))
    //   }
    //   callback()
    // }
    return {

      custom: [],
      statusing: '',
      statussess: '',
      statusno: '',
      countPpMoney: '',
      countActualMoney: '',
      activeNames: [''],
      count: '',
      danCount: '',
      npage: 1,
      categoryPerPage: 30,
      total: null,
      searcher: {
        company_id: '',
        the_founder: '',
        app_status: '',
        doner_id: ''
      },
      searchForm: {
        companyId: ''
      },
      drawerTitle: '',
      searchCompanies: [],
      searchCompaniesx: [],
      policyObj: [],
      adminUserOptions: [],
      companyPolicy: [],
      FOptions: [],
      policyInfoArr: [],
      header: {},
      searchArr: {
        category_id: ''
      },
      addForm: {
        company_id: '',
        policy_id: '',
        app_why: '',
        pp_money: '',
        the_founder: '',
        doner_id: ''
      },
      editForm: {
        company_id: '',
        policy_id: '',
        pp_money: '',
        app_status: '',
        sh_why: '',
        actual_money: '',
        dais: '',
        rejected: '',
        doner_id: ''
      },
      categoryIndrawer: false,
      success: false,
      EditDrawer: false,
      searchLoading: false,
      distributeDrawer: false,
      policyInfoDrawer: false,
      rules: {
        company_id: [
          {
            validator: CompanyId,
            required: true,
            trigger: 'blur'
          }
        ],
        policy_id: [
          {
            validator: PolicyId,
            required: true,
            trigger: 'blur'
          }
        ],
        pp_money: [
          {
            validator: PpMoney,
            required: true,
            trigger: 'blur'
          }
        ],
        actual_money: [
          {
            validator: ActualMoney,
            required: true,
            trigger: 'blur'
          }
        ],
        doner_id: [
          {
            validator: DonerId,
            required: true,
            trigger: 'blur'
          }
        ],
        the_founder: [
          {
            validator: TheFounder,
            required: true,
            trigger: 'blur'
          }
        ],
        app_status: [
          {
            validator: AppStatus,
            required: true,
            trigger: 'blur'
          }
        ],
        app_why: [
          {
            validator: AppWhy,
            required: true,
            trigger: 'blur'
          }
        ]
        // rejected: [
        //   {
        //     validator: Rejected,
        //     required: true,
        //     trigger: 'blur'
        //   }
        // ]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
    this.loadAdminUser()
  },
  methods: {
    handlePolicyInfo (pid, cname) {
      this.$axios
        .get('api/admin/policy/policyinfo?pid=' + pid)
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.policyInfoArr = data.data.policyInfo
            this.policyInfoArr['company_name'] = cname
            this.policyInfoDrawer = true
          }
        })
    },
    handleOrderInfoClose (done) {
      this.policyInfoDrawer = null
      done()
    },
    openDistribute (row) {
      this.$axios
        .get('api/admin/policy/getcomuserfun?company_id=' + row.company_id)
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.policyObj = data.data
          }
        })
      this.loadAdminUser()
      this.editForm = {...row}
      this.editForm.dais = this.editForm.app_status
      this.$axios
        .get('api/admin/policy/feedfunction?id=' + row.id)
        .then(({ data }) => {
          if (data.code === 0) {
            this.FOptions = data.data.FOptions
            this.distributeDrawer = true
          }
        })
        .catch()
    },
    appStatus (e) {
      if (e === '1') {
        this.success = false
        this.editForm.actual_money = ''
      }
      if (e === '2') {
        this.success = true
      }
      if (e === '3') {
        this.success = false
        this.editForm.actual_money = ''
      }
    },
    loadAdminUser () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data
          }
        })
        .catch()
    },
    searchRemoteCompanyMethodS (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanysx(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompaniesx = []
      }
    },
    searchArrItemCompanysx (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesx = data.data.companies
        }
      })
    },
    toSearch (val) {
      this.searcher.company_id = val
      this.npage = 1
    },
    founderUserfun (val) {
      this.searcher.the_founder = val
      this.npage = 1
    },
    donerUserfun (val) {
      this.searcher.doner_id = val
      this.npage = 1
    },
    compAppStatus (val) {
      this.searcher.app_status = val
      this.npage = 1
    },
    getComUser (val) {
      if (val) {
        this.$axios
          .get('api/admin/policy/getcomuserfun?company_id=' + val)
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.policyObj = data.data
            }
          })
      }
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanys(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/admin/policy/addform', {
              params: {
                addForm: this.addForm
              }
            })
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.resetForm('addForm')
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    loadTable () {
      this.addForm.company_id = ''
      this.addForm.policy_id = ''
      this.addForm.pp_money = ''
      this.addForm.doner_id = ''
      this.addForm.app_why = ''
      this.$axios
        .post('api/admin/policy/comppolicylist?page=' + this.npage, {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            console.log('====8888====', data)
            this.companyPolicy = Array.isArray(data.data.companyPolicy.data) ? data.data.companyPolicy.data : []
            this.total = data.data.companyPolicy.total
            this.count = data.data.count
            this.danCount = data.data.danCount
            this.statusing = data.data.statusing
            this.statussess = data.data.statussess
            this.statusno = data.data.statusno
            this.countPpMoney = data.data.pp_money
            this.countActualMoney = data.data.actual_money
          }
        })
        .catch()
    },
    editRow (row) {
      this.$axios
        .get('api/admin/policy/getcomuserfun?company_id=' + row.company_id)
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.policyObj = data.data
          }
        })
      this.loadAdminUser()
      this.editForm = {...row}
      this.EditDrawer = true
    },
    tiJiaoFun (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/admin/policy/tijiaofun', this.editForm)
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.EditDrawer = false
                this.distributeDrawer = false
                this.resetForm('editForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editFormFun (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/admin/policy/editcomppolicy', this.editForm)
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.EditDrawer = false
                this.resetForm('editForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 上面是新的
    loadRadio () {
      this.companyPolicy.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.companyPolicy.map(item => {
        this.listSort[item.id] = Number(item.sort)
        this.tableEdit.money[item.id] = Number(item.money)
        this.tableEdit.num[item.id] = Number(item.num)
        this.tableEdit.duration[item.id] = Number(item.duration)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/schedulesecond/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    loadCategory (e) {
      this.$axios.get('/api/admin/policy/shaixuanzheche?policy_id=' + e).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.categoryIdOptions = data.data.policyObj
          console.log(this.categoryIdOptions)
        }
      })
        .catch()
    }
  }
}
</script>

<style>
  th,td{
    height: 40px;
    padding: 5px 10px 5px;
  }
  th{
    width: 10%;
  }
  th{
    width: 15%;
  }
</style>

<style scoped>
.schedule {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.schedule >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.middle-table{
    z-index: 1;
  }

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}

.middle-table {
  z-index: 1;
}

#servicein >>> .el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: none;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
  color: #334;
  font-weight: 700;
}

.item-title {
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.item-row {
  margin-top: 0.2rem;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_policy/ApplicationPolicy.vue